import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import isEmpty from "lodash/isEmpty";

import * as routines from "../routines";
import { FormElements, Preloader } from "components";

const TRANSLATION_BASE = "modules.teacher";

export default ({ isOpen = false, data = {}, onClose = () => {} }) => {
  const dispatch = useDispatch();
  const image = useSelector(state => state.Teacher.image);

  const { t } = useTranslation();

  const isNew = isEmpty(data);
  let title = t(`${TRANSLATION_BASE}.new_teacher`);

  if (!isNew) {
    title = t(`${TRANSLATION_BASE}.update_teacher`);
  }

  return (
    <Modal isOpen={isOpen} size="half">
      <Formik
        enableReinitialize
        initialValues={{
          name: "",
          email: "",
          password: "",
          password_confirmation: "",
          phone_number: ""
        }}
        validationSchema={() =>
          Yup.object().shape({
            // image: Yup.string().required(),
            name: Yup.string().required(t("global.validation.field_is_required")),
            email: Yup.string().required(t("global.validation.field_is_required")).email(t("global.validation.field_contain_at")),
            password: Yup.string()
              .required(t("global.validation.field_is_required"))
              .min(6, t("global.validation.too_short")),
            password_confirmation: Yup.string()
              .oneOf([Yup.ref("password"), null], t("global.validation.passwords_must_match"))
              .required(t("global.validation.field_is_required")),
            phone_number: Yup.string().required(t("global.validation.field_is_required"))
          })
        }
        onSubmit={(values, { setSubmitting }) => {
          dispatch(
            routines.create({
              values: { ...values, password_confirmation: values.password },
              onSuccess: () => {
                setSubmitting(false);
                toast.success(t("global.notification.success"), {
                  position: toast.POSITION.TOP_RIGHT
                });
                onClose();
              },
              onError: (error = {}) => {
                setSubmitting(false);
                toast.error(t("global.error_occurred"), {
                  position: toast.POSITION.TOP_RIGHT
                });
              }
            })
          );
        }}>
        {({ isSubmitting, setFieldValue, handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Preloader loading={isSubmitting}>
                <ModalHeader toggle={onClose}>{title}</ModalHeader>
                <ModalBody className="p-4">
                  <Row>
                    <Col md={12}>
                      <Row>
                        <Col md={12}>
                          {/* <div className="mb-3">
                            <h5 className="text-uppercase mt-0 mb-3 bg-light p-2">{t(`${TRANSLATION_BASE}.image`)}</h5>
                            <Field
                              name="image"
                              loading={image.loading}
                              uploadText={t("upload.upload")}
                              changeText={t("upload.change")}
                              onUpload={file => {
                                const onSuccess = response => {
                                  setFieldValue("image", response?.image);
                                  setFieldValue("thumbnail", response?.thumbnail);
                                };
                                const onError = error =>
                                  toast.error(t("global.error_occurred"), { position: toast.POSITION.TOP_RIGHT });

                                dispatch(routines.uploadImage({ file, onSuccess, onError }));
                              }}
                              component={FormElements.Upload}>
                              <div className="dz-message needsclick" style={{ margin: "2em" }}>
                                <i className="h1 text-muted dripicons-cloud-upload" />
                                <h3>{t("global.upload")}</h3>
                              </div>
                            </Field>
                          </div> */}
                          <Field
                            name="name"
                            label={t(`${TRANSLATION_BASE}.full_name`)}
                            placeholder={t(`${TRANSLATION_BASE}.full_name`)}
                            component={FormElements.Input}
                          />
                        </Col>
                        <Col md={12}>
                          <Field
                            name="email"
                            label={t(`${TRANSLATION_BASE}.email`)}
                            placeholder={t(`${TRANSLATION_BASE}.email`)}
                            component={FormElements.Input}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12}>
                      <Row>
                        <Col md={12}>
                          <Field
                            name="phone_number"
                            label={t(`${TRANSLATION_BASE}.phone_number`)}
                            component={FormElements.PhoneInput}
                          />
                        </Col>
                        <Col md={6}>
                          <Field
                            name="password"
                            label={t(`${TRANSLATION_BASE}.password`)}
                            placeholder={t(`${TRANSLATION_BASE}.enter_password`)}
                            component={FormElements.Input}
                          />
                        </Col>
                        <Col md={6}>
                          <Field
                            name="password_confirmation"
                            label={t(`${TRANSLATION_BASE}.confirm_password`)}
                            placeholder={t(`${TRANSLATION_BASE}.enter_password`)}
                            component={FormElements.Input}
                          />
                        </Col>
                        {/* <Col md={12}>
                          <Field
                            name="brief_introduction"
                            label={t(`${TRANSLATION_BASE}.brief_introduction`)}
                            component={FormElements.Editor}
                          />
                        </Col> */}
                      </Row>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <button type="button" className="btn btn-secondary waves-effect" onClick={() => onClose()}>
                    {t("global.close")}
                  </button>
                  <button type="submit" className="btn btn-info waves-effect waves-light">
                    {t("global.save_changes")}
                  </button>
                </ModalFooter>
              </Preloader>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};
